export default "__VITE_ASSET__667a4102__"